export const MaxAttachmentSizeBytes: number = 15728640; //15MB
